'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartProduct = undefined;

var _CartProduct2 = require('./CartProduct');

var _CartProduct3 = _interopRequireDefault(_CartProduct2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CartProduct = _CartProduct3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/CartProduct/index.js
// module id = 1805
// module chunks = 0